/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-enable  @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigationTabsPersonProfile, personIntentData, personNews,
  personProfileName, personWorkbenchData, personWorkbenchLoading, selectIsEmptyStats,
  selectSocialCall,
  selectSocialFlurry,
} from 'Selector/PersonProfileSelector';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import { WorkbenchStatsResponseType } from 'Types/PersonTypes';
import WorkbenchStat from 'Components/common/components/WorkbenchStat';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  isFreeUser, valueToObject,
} from 'Utils/UtilityFunctions';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import classNames from 'classnames';
import { PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';
import styled from 'styled-components';
import {
  boxShadow, maxMobile, midMobile, white,
} from 'Utils/utilsStyle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import PersonIntentData from './PersonIntentData';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media all and (max-width: ${maxMobile}) {
    gap: 24px;
  }

  .tagsAndIntentDataWrapper{
    padding: 24px;
    background: ${white};
    border-radius: 16px;
    box-shadow: ${boxShadow};
    display: flex;
    flex-direction: column;
  }
  .tagsAndArticleWrapper{
    display: flex;
    gap: 12px 22px;
    margin-bottom: 0;

    .personIntentData {

      .workbenchStatWrapperPerson {
        height: 100%;
        /* .intent-data-wrap {
          max-height: 305px;
          overflow: hidden; 
        } */
      }

      .buttonsPart{
        @media all and (max-width: ${midMobile}){
          flex-direction: column;
        }
      } 
    }

    &.listview{
      flex-direction: column-reverse;
      
      .personIntentData{
        padding-right: 0;
        margin-right: 0;
      }
    }

    .tagsWrapper{
      margin-bottom: 0;

      .listViewIntentData {
        margin-bottom: 0;
      }
    }
  }

  .spotlightWrapper{
    padding: 24px 12px;
    background: ${white};
    box-shadow: ${boxShadow};
    border-radius: 16px;

    @media all and (max-width: ${maxMobile}) {
      padding: 16px 0px;
    }

    .heading-inner-page{
      padding: 0 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;

      .right-side-sub-header {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-left: auto;

        .view-tabs {
          pointer-events: auto;
        }
      }

      @media all and (max-width: ${maxMobile}) {
        padding: 0px 10px;
      }
    }

    .personNewsArticlesWrapper{

      .infiniteScrollWrapper{
        padding: 0 12px;
        padding-top: 20px;

        @media all and (max-width: ${maxMobile}) {
          padding: 0px 10px;
          padding-top: 12px;
        }
      }
    }
  }
  .dynamicWidth {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .mb-16 {
    margin-bottom: 16px;
  }
`;

type Props = {
  personId: number;
  personType: string;
  listview?: boolean;
  headerActions?: React.ReactNode;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

const PersonNews: React.FC<Props> = function PersonNews({ personId, personType, listview, headerActions }) {
  const dispatch = useDispatch();
  const {
    articles, loading, page,
  } = useSelector(personNews);
  const personName = useSelector(personProfileName);
  const tabs = useSelector(navigationTabsPersonProfile);
  const flurryObject = useSelector(selectSocialFlurry);
  const isCalled = useSelector(selectSocialCall);
  const [showSection, setShowSection] = useState(true);
  const personWorkbenchStats: WorkbenchStatsResponseType[] = useSelector(personWorkbenchData);
  const personWorkbenchStatsLoading: boolean = useSelector(personWorkbenchLoading);
  const isEmptyStats: boolean = useSelector(selectIsEmptyStats);
  const navigate = useNavigate();

  const {
    data, loading: intentLoading, intentAllowed, url,
  } = useSelector(personIntentData);

  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const personIdURL = urlParams.get('personId');
    if (!loading && articles.length === 0 && !tabs.includes('News')) {
      const navLink = `${PERSONALITY_INSIGHTS_ROUTE}${personId || personIdURL}&personType=${personType || 'EXECUTIVE'}`;
      navigate(navLink, { replace: true });
    }
  }, [personId, tabs]);

  useEffect(() => {
    if (Object.keys(flurryObject).length) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('executive_news', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(personProfileActions.setSocialCall(true));
    }
  }, [flurryObject]);

  const loadMore = () => {
    if (!loading) {
      dispatch(personProfileActions.getPersonProfileNews(
        { personId, type: personType, page: page + 1 },
      ));
    }
  };
  useEffect(() => {
    if (!loading && !articles?.length && isEmptyStats) setShowSection(false);
    else setShowSection(true);
  }, [loading, articles]);
  return (
    showSection
      ? (
        <Wrapper>
          {/* Need to fix this portion for now focused on articles only */}
          {!listview ? (
            <div className="tagsAndArticleWrapper">
              {data.length === 0 && isEmptyStats ? (
                null
              ) : (
                data.length > 1 && (
                  <div className="tagsAndIntentDataWrapper">
                    <div className="heading-inner-page mb-16">
                      {!intentLoading ? <h1 className="heading">Engagement Overview</h1> : <SkeletonCustom width="210px" height="45px" diameter="10px" />}
                    </div>
                    <Row gutter={16}>
                      {!intentLoading && data.length ? (
                        <Col
                          span={12}
                          xs={24}
                          sm={24}
                          md={12}
                          className={classNames('personIntentData article-grid', { dynamicWidth: isEmptyStats && !isFreeUser() })}
                        >
                          <PersonIntentData
                            name={personName}
                            keywords={data}
                            loading={intentLoading}
                            intentAllowed={intentAllowed}
                            url={url}
                            listview={listview}
                            className="workbenchStatWrapperPerson"
                          />

                        </Col>
                      ) : null}
                      {!isEmptyStats && !isFreeUser()
                        && (
                          <Col
                            span={12}
                            xs={24}
                            sm={24}
                            md={12}
                            className={classNames('article-grid', { dynamicWidth: data.length === 0 })}
                          >
                            <WorkbenchStat
                              loading={personWorkbenchStatsLoading}
                              stats={personWorkbenchStats}
                              listview={listview}
                            />
                          </Col>
                        )}
                    </Row>
                  </div>
                )
              )}
            </div>
          )
            : (
              <div className="listviewTagsAndStatsWrapper classToMakePrecedenceHigh">
                {!intentLoading && !isEmptyStats && !isFreeUser()
                  && (
                    <div className={classNames('workbenchStatWrapper', {
                      dynamicWidth:
                        data.length === 0,
                    })}
                    >
                      <h2 className="headingText">
                        Workbench Engagement
                      </h2>
                      <WorkbenchStat
                        loading={personWorkbenchStatsLoading}
                        stats={personWorkbenchStats}
                        listview={listview}
                      />
                    </div>
                  )}

                {!intentLoading
                  && data.length > 0
                  ? (
                    <div className="intentDataWrapper">
                      <PersonIntentData
                        name={personName}
                        keywords={data}
                        loading={intentLoading}
                        intentAllowed={intentAllowed}
                        url={url}
                        listview={listview}
                        className="workbenchStatWrapperPerson"
                      />
                    </div>
                  )
                  : null}
              </div>
            )}

          {articles.length ? <div className="spotlightWrapper parentClassToHighPrecedence">
            <div className="heading-inner-page">
              <h1 className="heading">
                News
              </h1>
              {headerActions ? (
                <div className="right-side-sub-header">
                  {headerActions}
                </div>
              ) : null}
            </div>
            <div className="personNewsArticlesWrapper">
              <InfiniteScroll
                dataLength={articles.length}
                next={loadMore}
                hasMore
                loader={loading
                  && (listview
                    ? <ArticleListLoadingSkeletonBundle /> : <ArticleLoadingSkeletonBundle />)}
                className={classNames('o-x-hidden o-y-hidden infiniteScrollWrapper', { listview })}
              >
                <ArticleGridLayout
                  isLoading={loading}
                  articlesArray={articles}
                  listview={listview}
                />
              </InfiniteScroll>
            </div>
          </div> : null}
        </Wrapper>
      ) : null
  );
};

PersonNews.defaultProps = defaultProps;
export default PersonNews;
